import { SaveButton, Toolbar } from 'react-admin'

const MailServiceConfigEditToolBar = () => {

  return (
    <Toolbar>
      <SaveButton />
    </Toolbar>
  )
}

export default MailServiceConfigEditToolBar